var buttonSlot = 'fx_2d2fb1e5_13qi7iy0';

export { buttonSlot };
//# sourceMappingURL=slot.vanilla.mjs.map
